import {
  TimelineMax,
  Power3,
  Elastic,
  Expo,
} from 'gsap';
import { random } from 'lodash';
import { layout } from '../../scripts/layout';
import hades from '../../scripts/hades';
import u from '@/scripts/utils';

const FloweFall = (flower) => {
  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(flower.scale, 0.8, {
      x: (u.isTouchDevice() ? 1 : 0.5) * layout.viewport.ratio.width,
      y: (u.isTouchDevice() ? 1 : 0.5) * layout.viewport.ratio.width,
      ease: Elastic.easeOut,
    }, 'start')
    .to(flower.position, 3, {
      y: layout.viewport.actual.height * 2 + hades.ref.amount.y,
      ease: Expo.easeIn,
    }, 'start')
    .to(flower, 3, {
      angle: random(-90, 90),
      ease: Expo.easeIn,
    }, 'start')
    .to(flower, 0.4, {
      alpha: 0,
      ease: Power3.easeOut,
    }, 'start+=2.6');
  return tl;
};

export default FloweFall;
